import { formatCustomDate } from "helpers/dateTools";
import { SUPERVISION_TYPES } from "helpers/supervisionTypes";

export const SET_SUPERVISION_FILTERS = "SET_SUPERVISION_FILTERS";
export const GET_SUPERVISION = "GET_SUPERVISION";
export const CHECK_SUPERVISION_ITEM = "CHECK_SUPERVISION_ITEM";
export const POST_SUPERVISION = "POST_SUPERVISION";
export const RESTORE_SUPERVISION_INITIAL = "RESTORE_SUPERVISION_INITIAL";

const INITIAL_STATE = {
  supervision: [],
  selectedSettlements: [],
  selectedManualNotes: [],
  date: formatCustomDate(new Date(), "-"),
  station: null,
  idInventory: "",
  counter: 0,
  counterAmount: 0,
};

export const supervisionReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SET_SUPERVISION_FILTERS: {
      let supervision = state.supervision;
      if (payload.key === 'station') supervision = [];
      return { ...state, [payload.key]: payload.data, supervision };
    }

    case GET_SUPERVISION:
      return {
        ...state,
        supervision: payload.data,
        idInventory: payload.idInventory,
        selectedSettlements: [],
        selectedManualNotes: [],
        counter: 0,
        counterAmount: 0,
      };

    case CHECK_SUPERVISION_ITEM: {
      const { id, itemType } = payload;
      const list = state.supervision.map(item =>
        item.id_settlement === id && item.type === itemType
          ? { ...item, checked: !item.checked }
          : item
      );

      const selectedSettlements = [];
      const selectedManualNotes = [];
      let counter = 0;
      let counterAmount = 0;

      list.forEach(item => {
        if (item.checked) {
          counter += item.kilos || 0;
          counterAmount += item.total_amount || 0;
          if (item.type === SUPERVISION_TYPES.SETTLEMENT) selectedSettlements.push(item.id_settlement);
          if (item.type === SUPERVISION_TYPES.MANUAL_NOTE) selectedManualNotes.push(item.id_settlement);
        }
      });

      return {
        ...state,
        supervision: list,
        selectedSettlements,
        selectedManualNotes,
        counter,
        counterAmount,
      };
    }

    case POST_SUPERVISION: {
      const { settlements = [], manualNotes = [] } = payload;
      const allPosted = [...settlements, ...manualNotes];
      const filtered = state.supervision.filter(
        x => !allPosted.includes(x.id_settlement)
      );
      return {
        ...state,
        supervision: filtered,
        selectedSettlements: [],
        selectedManualNotes: [],
        counter: 0,
        counterAmount: 0,
      };
    }

    case RESTORE_SUPERVISION_INITIAL:
      return INITIAL_STATE;

    default:
      return state;
  }
};
